<template>
    <div class="training-container" :class="{ 'last-step': isFinalStep }">
        <Loader v-if="isLoadingAnimatedOutfits" />
        
        <div v-else style="height: 100%; width: 100%;">
            <div class="training-step-body">
                <PerfectOutfit v-if="isTrainingComplete" />
                <component v-if="!isTrainingComplete" :is="'step-'+ currentStep"></component>
            </div>

            <div class="training-step-footer">
                <div class="button-container">
                    <div
                        v-if="isTrainingComplete || !isFinalStep"
                        @click.stop="nextStep"
                        class="button pink next-button">{{nextButtonText}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from "../common/loader.vue";
    import Mixins from "../../mixins/mixins";
    import SwipeLeft from "./training/swipe-left.vue";
    import SwipeRight from "./training/swipe-right.vue";
    import Swap from "./training/swap.vue";
    import PerfectOutfit from "./training/perfect-outfit.vue";
    import SwipeOutfits from "./training/swipe-outfits.vue";
    import StepCounter from "./training/step-counter.vue";
    import { mapGetters } from 'vuex';

    export default {
        mixins: [Mixins],
        components: {
            'step-1': SwipeRight,
            'step-2': SwipeLeft,
            'step-3': Swap,
            'step-4': SwipeOutfits,
            PerfectOutfit,
            StepCounter,
            Loader,
        },
        created() {
            this.$on('completedTraining', () => {
                this.isTrainingComplete = true;
            });
            //Only load outfits on first step
            if(this.currentStep === 1) {
                this.$store.commit('menu/setCurrentProgressStep', this.onboardingTotalSteps + 1);
                this.$store.dispatch("onboarding/loadAnimationOutfits").then(outfits => {
                    if (outfits.length === 0) {
                        this.trainingCompleted();
                    }
                });
            }
        },
        data() {
            return {
                totalSteps: 4,
                dataSaving: false,
                isTrainingComplete: false
            };
        },
        computed: {
            isFinalStep() {
                return this.currentStep === this.totalSteps;
            },
            currentStep() {
                return parseInt(this.$route.params.id);
            },
            nextButtonText() {
                if (this.isFinalStep) {
                    return 'Get Styled';
                }
                if (this.currentStep === this.totalSteps - 1) {
                    return 'Let\'s go';
                }
                return 'Next';
            },
            ...mapGetters({
                isLoadingAnimatedOutfits: 'onboarding/isLoadingAnimatedOutfits',
                currentProgressStep: 'menu/getCurrentProgressStep',
                onboardingTotalSteps: "onboarding/numberOfSteps",
            }),
        },
        methods: {
            stopTraining() {
                this.$router.push({path: '/account/complete'});
            },
            nextStep() {
                this.$store.commit('menu/setCurrentProgressStep', this.currentProgressStep + 1);
                this.$store.commit('onboarding/nextAnimationOutfit');
                
                if (this.currentStep < this.totalSteps) {
                    this.$router.push({
                        path: `/training/${this.currentStep + 1}`
                    });
                } else {
                    console.log('Go to normal app now');
                    this.stopTraining();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .training-container,
    .training-step-body {
        height: 100%;
        width: 100%;
    }
    .training-container.last-step {
        align-content: center;
        align-items: center;
        display: flex;
        flex-flow: row;
    }
    .training-step-footer {
        position: fixed;
        bottom: 20px;
        width: 100%
    }
    .button-container {
        text-align: center;
    }
    .next-button {
        font-size: 16px;
        letter-spacing: -0.6px;
        font-weight: bold;
        height: 46px;
        border-radius: 23px;
        width: 100%;
        padding: 0 32px;
    }
    .last-step .next-button {
        padding: 0 40px;
    }
    .close-icon {
        position: absolute;
        right: 30px;
        top: 30px;
        z-index: 100;
    }
</style>
